import { ReactNode } from 'react';
import { classNames } from '@utils/classNames.ts';

export type ScrollableSectionProps = {
  title: string;
  children: ReactNode;
  className?: string;
};

export function ScrollableSection({
  title,
  children,
  className,
}: ScrollableSectionProps) {
  return (
    <div className={classNames('w-full', className)}>
      {/* Header */}

      <h2 className="font-semibold text-lg text-dark mb-6">{title}</h2>

      {/* Scrollable Container */}
      <div className="relative">
        <div className="overflow-x-auto pb-4 flex gap-6 snap-x snap-mandatory">
          {/* This wrapper ensures proper spacing and snap behavior */}
          <div className="flex gap-6 min-w-min">{children}</div>
        </div>
      </div>
    </div>
  );
}
